export default defineNuxtRouteMiddleware(async (to, from) => {
    if ( to.path ) {
        const url = btoa(to.path)
        const { data, error } = await useAsyncData(`redirects:${url}`, () => $fetch('/api/redirects', { params: { url: url } }))
        if (data?.value?.destination && !data.value.destination.startsWith("http")) return navigateTo(data.value.destination, { redirectCode: data?.value?.code ? data.value.code : 302 })
        else if (data?.value?.destination && data.value.destination.startsWith("http")) return navigateTo(data.value.destination, { redirectCode: data?.value?.code ? data.value.code : 302, external: true })
    }
})